export const UNIVERSAL_ACTION_POLICY_ADDRESS = '0x0000006DDA6c463511C4e9B05CFc34C1247fCF1F';
export const MAX_RULES = 16;
//# sourceMappingURL=constants.js.map